// without a machine this would send machineId=undefined, which Dashboard rejects
export const workflowsQueryOptions = (machine) => {
  return {
    variables: { machineId: machine?.id },
    skip: !machine?.id,
  };
};
